import { FunctionCallAction, Transaction } from '@near-wallet-selector/core';
import { DEFAULT_GAS, STORAGE_TO_REGISTER_WITH_MFT } from '../constants';
import { loadAccountStorageBalance } from '../fetchers/loadAccountStorageBalance';
import { Provider } from '../types';

export async function registerToken(
  provider: Provider,
  tokenId: string,
  user: string
): Promise<Transaction | undefined> {
  const tokenOutActions = new Array<FunctionCallAction>();
  const { storageBalance: tokenRegistered } = await loadAccountStorageBalance({
    provider,
    tokenId,
    tokenOwnerId: user,
  });

  if (tokenRegistered) {
    return undefined;
  }

  tokenOutActions.push({
    type: 'FunctionCall',
    params: {
      methodName: 'storage_deposit',
      args: {
        registration_only: true,
        account_id: user,
      },
      gas: DEFAULT_GAS,
      deposit: STORAGE_TO_REGISTER_WITH_MFT,
    },
  });

  return {
    receiverId: tokenId,
    signerId: user,
    actions: tokenOutActions,
  };
}
